import React, { useEffect } from 'react'
import blog1 from '../../assets/images/blog_aws.jpg'
import blog2 from '../../assets/images/blog_recat.png'
import blog3 from '../../assets/images/blog_success.png'
import blog4 from '../../assets/images/blog_AI.png'
import blog5 from '../../assets/images/blog_hackthon.png'
import blog6 from '../../assets/images/blog_dreamjob.png'
import blog7 from '../../assets/images/blogs_partnership.png'
import blog8 from '../../assets/images/blog_cybersecurity.png'
import blog9 from '../../assets/images/blog_development.png'
import blog10 from '../../assets/images/blog-quantum-computing.jpg'

import AOS from 'aos';
import 'aos/dist/aos.css';



const Blogs = () => {

    useEffect(() => {
        AOS.init();
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top of the page
    }, []);

    return (

        <>

            <div className="floating-icons">
                <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
                    <button

                        className="sm_icon"
                    >
                        <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
                    </button>
                </a>
                <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
                    </button>
                </a>
                <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
                    </button>
                </a>
                <a className="icon" href="https://wa.me/+918688964015" target="_blank">
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
                    </button>
                </a>
            </div>


            <div className='Home_Blogs_section' style={{ marginTop: "100px" }}>
                <div className='container-fluid'>
                    <div className='Home_blogs_sectionheads' data-aos="zoom-in" data-aos-duration="2000">
                        <h1 style={{ color: "#e65753" }}>Newest Stories</h1>
                        {/* <p>Stay up to date with all the exciting happenings at Hamo Tech. Our institute is committed to offering the latest training, workshops, and events to keep you ahead in the tech world. Check out our latest updates and news below</p> */}

                        <p>At <span style={{ color: "#e65753" }}>Hamo Tech</span>, innovation and career advancement are at the heart of everything we do. With the launch of our new AWS Cloud Mastery Program, we’re empowering students to master the skills needed to optimize and manage cutting-edge cloud infrastructures. Additionally, our React Development Bootcamp is providing a golden opportunity for aspiring developers to dive deep into the world of front-end frameworks, ensuring they stay ahead in this ever-evolving tech landscape. Both programs are designed to be immersive and practical, offering students hands-on experience and industry-relevant knowledge.</p>

                        {/* <p>We’ve also introduced specialized workshops and webinars tailored to the demands of today’s tech industry. From AI in education to cybersecurity essentials, our sessions are curated by experts to help students tackle real-world challenges. Whether it's understanding machine learning algorithms or safeguarding networks against cyber threats, these programs equip learners with the expertise needed to excel in their careers. Furthermore, our free webinar on Quantum Computing opens up a fascinating realm of possibilities, introducing participants to a revolutionary technology that’s shaping the future of innovation.</p> */}
                    </div>

                    <div className='row mt-4'>
                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1000">
                            <div className='card'>
                                <div>
                                    <img src={blog1} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Hamo Tech Launches New AWS Training Program</a>
                                    </h4>
                                    <p className='text-justify'>We are excited to announce the launch of our new AWS Cloud Mastery Program! This advanced course will equip students with the skills needed to manage and optimize cloud infrastructures using AWS. Enrollment is now open for our upcoming cohort starting January 2025.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1500">
                            <div className='card'>
                                <div>
                                    <img src={blog2} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>New React Development Bootcamp Announced</a>
                                    </h4>
                                    <p className='text-justify'>Our highly anticipated React Development Bootcamp is now open for registration! This one-day intensive workshop will cover everything you need to know about building dynamic applications with React.js. Don’t miss out—secure your spot before it fills up!</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="2000">
                            <div className='card'>
                                <div>
                                    <img src={blog3} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Student Success Stories: Graduates Securing Top Tech Jobs</a>
                                    </h4>
                                    <p className='text-justify'>The first Hamo Tech Developer Conference was a huge success! Featuring talks from industry experts, live coding sessions, and networking opportunities, the event attracted hundreds of aspiring tech professionals. Stay tuned for next year’s conference dates!</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row mt-4'>
                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1000">
                            <div className='card'>
                                <div>
                                    <img src={blog4} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>AI in Education: Hamo Tech Integrates AI Modules</a>
                                    </h4>
                                    <p className='text-justify'>Discover how our new AI-focused modules are transforming tech education. From machine learning basics to advanced algorithms, students gain hands-on experience in AI technologies.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>15 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1200">
                            <div className='card'>
                                <div>
                                    <img src={blog5} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Hamo Tech Hosts Hackathon for Emerging Developers</a>
                                    </h4>
                                    <p className='text-justify'>Join the excitement at our upcoming Hackathon! Test your coding skills, collaborate with peers, and compete for prizes. The event is open to developers of all levels.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>20 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1500">
                            <div className='card'>
                                <div>
                                    <img src={blog6} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Top Tips for Landing Your Dream Tech Job</a>
                                    </h4>
                                    <p className='text-justify'>Learn the secrets to acing technical interviews and building an impressive portfolio. Our experts share actionable advice to help you succeed in the competitive tech job market.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>25 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1800">
                            <div className='card'>
                                <div>
                                    <img src={blog7} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Hamo Tech Expands Partnership with Tech Giants</a>
                                    </h4>
                                    <p className='text-justify'>We’re proud to announce new collaborations with leading tech companies. This partnership provides students with unparalleled opportunities for internships and job placements.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>30 Aug 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="2000">
                            <div className='card'>
                                <div>
                                    <img src={blog8} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Cybersecurity Workshops Now Available</a>
                                    </h4>
                                    <p className='text-justify'>Stay ahead in the digital age with our new cybersecurity workshops. Learn to identify vulnerabilities and safeguard networks against cyber threats.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>05 Sep 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1000">
                            <div className='card'>
                                <div>
                                    <img src={blog9} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Full-Stack Development Course: New Batch Announcement</a>
                                    </h4>
                                    <p className='text-justify'>Enroll in our comprehensive Full-Stack Development course, starting October 2024. Master front-end and back-end technologies with real-world projects.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>10 Sep 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1200">
                            <div className='card'>
                                <div>
                                    <img src={blog10} className='img-fluid' />
                                </div>
                                <div className='Home_Blogs_section_content'>
                                    <h4>
                                        <a href='#'>Introduction to Quantum Computing: Free Webinar</a>
                                    </h4>
                                    <p className='text-justify'>Don’t miss our free webinar on Quantum Computing! Understand the basics and explore how this revolutionary technology is shaping the future.</p>

                                    <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                    <hr />
                                    <div className='Home_Blogs_section_date'>
                                        <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                        {/* <p><span><i class="ri-time-line"></i></span>15 Sep 2024</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
            </div>

        </>
    )
}

export default Blogs
